<template>
	<Dialog title="Tvåstegsverifiering (SMS)" persistent ref="dialog" :width="700">
		<v-container fluid>
			<v-row dense>
				<v-col cols="12">
					<InputField
						autofocus
						:loading="isRequestingVerificationCode"
						placeholder=" "
						:error="invalidVerificationCode"
						:model="model"
						name="SMSCode"
						ref="SMSCode"
						prepend-icon="mdi-cellphone"
						@keyup.enter.stop.prevent="onVerify"
						:counter="4"
					/>
				</v-col>
				<v-col cols="12">
					<v-alert
						v-if="!isRequestingVerificationCode"
						border="top"
						colored-border
						type="warning"
						elevation="2"
						color="accent"
						class="caption"
						dense
					>
						Vi har skickat en veriferingskod till mobilnummret kopplat till ditt användarkonto. Vänligen fyll i den för att logga in.
					</v-alert>
				</v-col>
				<v-col cols="6">
				</v-col>
				<v-col cols="6">
				</v-col>
			</v-row>
		</v-container>

		<template v-slot:buttons="{hide}">
			<v-btn color="secondary" @click="hide" :disabled="isVerifying">Avbryt</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="primary" ref="SaveBtn" @click="onVerify" :loading="isVerifying" :disabled="isRequestingVerificationCode || model.SMSCode.length !== 4">Logga in</v-btn>
		</template>
	</Dialog>
</template>

<script>
import {noop}     from 'lodash';
import BaseModel  from '../models/BaseModel.js';
import Validate   from '../lib/Validate.js';
import InputField from './form/InputField.vue';
import Dialog     from './Dialog.vue';

class SMSVerification extends BaseModel {
	static get propertyMap() {
		return {
			SMSCode: {
				label:        'Verifieringskod',
				type:         String,
				defaultValue: '',
				rules:        [
					Validate.required,
				],
			},
		};
	}
}

export default {
	name: 'SMSVerificationDialog',

	data: () => ({
		invalidVerificationCode:      false,
		isRequestingVerificationCode: false,
		isVerifying:                  false,
		model:                        new SMSVerification(),
		requestData:                  {},
		onVerifiedCallback:           noop,
	}),

	methods: {
		show(requestData = {}, onVerifiedCallback = noop) {
			this.model                   = new SMSVerification();
			this.invalidVerificationCode = false;
			this.onVerifiedCallback      = onVerifiedCallback;
			this.requestData             = requestData;
			this.$refs.dialog.show();

			this.requestVerificationCode();
		},

		requestVerificationCode() {
			this.$tryCatch({
				task: async () => {
					this.isRequestingVerificationCode = true;

					await this.$http.post('/authenticate/requestSMSVerificationCode', this.requestData);
				},

				error: () => {
					this.$refs.dialog.hide();
				},

				finally: () => {
					this.isRequestingVerificationCode = false;
				},
			});
		},

		onVerify() {
			this.invalidVerificationCode = false;

			this.$tryCatch({
				task: async () => {
					this.isVerifying = true;

					const {SMSToken} = await this.$http.post('/authenticate/validateSMSVerificationCode', {
						...this.requestData,
						SMSCode: this.model.SMSCode,
					});

					this.onVerifiedCallback(SMSToken);
				},

				error: () => {
					this.invalidVerificationCode = true;
				},

				finally: () => {
					this.isVerifying = false;
				},
			});
		},
	},

	components: {InputField, Dialog},
}
</script>

<style scoped>

</style>
